/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * HPAUnsupportedReasonType explains why HPA V2 is unsupported for the workload.   - HPA_UNSUPPORTED_REASON_WORKLOAD_TYPE: Workload type/kind is not supported for HPA.  - HPA_UNSUPPORTED_REASON_TAKE_OWNERSHIP: Cannot take ownership of existing HPA (e.g. owned by third party or has unsupported metrics).
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1HPAUnsupportedReasonType = {
    UNKNOWN: 'HPA_UNSUPPORTED_REASON_UNKNOWN',
    WORKLOAD_TYPE: 'HPA_UNSUPPORTED_REASON_WORKLOAD_TYPE',
    TAKE_OWNERSHIP: 'HPA_UNSUPPORTED_REASON_TAKE_OWNERSHIP'
} as const;

export type WorkloadoptimizationV1HPAUnsupportedReasonType = typeof WorkloadoptimizationV1HPAUnsupportedReasonType[keyof typeof WorkloadoptimizationV1HPAUnsupportedReasonType];



